import type { UniqueIdentifier } from "@skilitics/drag-drop";

import { DND_RESIZEABLE_ID, DND_TRANSFORM_ORIGIN_ID } from "./dndConstants.ts";

export const createTransformOriginId = (nodeId: number) => `${DND_TRANSFORM_ORIGIN_ID}:${nodeId}`;

export const isTransformOriginId = (identifier: UniqueIdentifier) =>
  typeof identifier === "string" && identifier.split(":")[0] === DND_TRANSFORM_ORIGIN_ID;

export const parseTransformOriginId = (identifier: UniqueIdentifier): number => {
  if (typeof identifier === "number") throw new Error("Invalid transform origin identifier.");
  const [type, nodeId] = identifier.split(":");
  if (type !== DND_TRANSFORM_ORIGIN_ID) throw new Error("Invalid transform origin identifier.");
  return Number(nodeId);
};

export const isInlineRole = (typeId: string) => ["flexbox.container"].includes(typeId);

export const createResizeableId = (id: string, layoutableId: number) => `${id}:${DND_RESIZEABLE_ID}:${layoutableId}`;

export const parseResizeableId = (identifier: UniqueIdentifier) => {
  if (typeof identifier === "number") throw new Error("Invalid resizable identifier.");

  const [id, draggableType, layoutableId] = identifier.split(":");

  if (draggableType !== DND_RESIZEABLE_ID) throw new Error("Invalid resizable identifier.");

  return { id, draggableType, layoutableId: Number(layoutableId) };
};

export const isResizeableId = (identifier: UniqueIdentifier) =>
  typeof identifier === "string" && identifier.split(":")?.[1] === DND_RESIZEABLE_ID;
